import {Box} from "@mui/material";

export const Spacer = ({ height }: { height: number }) => <Box sx={{ height: height }} />;